RivalIQ.apps.Reports.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const Configuration = Marionette.Dashboard.models.Configuration.extend({
        urlRoot: function () {
            const me = this;
            return `/api/reports/definitions/${me.get('curation_id')}`;
        }
    });

    const Dashboard = RivalIQ.apps.Dashboard;
    const CollectionView = Dashboard.views.ColumnWidgets.extend({
        columnBootstrapSize: 'lg'
    });

    const PdfLayout = Dashboard.views.ExportWidgets.extend({
        childView: CollectionView
    });

    curations.Report = Dashboard.models.Curation.extend({
        title: function () {
            const me = this;
            return me.getName();
        },
        exportWidgetsView: PdfLayout,

        getCurationId: function () {
            const me = this;
            return me.getProp('reportId');
        },

        // Each report only supports a single format
        getReportFormat: function () {
            const me = this;
            return me.getExportFormats()[0];
        },

        getExportFormats: function () {
            const me = this;
            return me.configuration.get('exportFormats');
        },

        getExportTypes: function () {
            const me = this;
            return me.configuration.get('exportTypes');
        },

        csvExportProps: function (props) {
            const me = this;

            return _.extend(props, {
                timePeriod: me.getProp('timePeriod'),
                companySetDescriptor: me.getProp('companySetDescriptor'),
                type: me.configuration.get('csvExportType'),
                reportType: me.configuration.get('id'),
                dailyValues: me.getProp('dailyValues')
            });
        },

        getBasePath: function (overrides) {
            const me = this;

            return me.router.resolveCurationRoute(me.id, _.extend({
                reportId: me.getProp('reportId')
            }, overrides));
        },

        emptyConfigurationView: Marionette.ItemView.extend({
            template: () => `
                <div class="widget-error-no-secondary-nav">
                  <img class="img-sm-vertical center-block" src="/images/sad_graphs.png">
                  <h4 class="text-center">That report seems to have disappeared.</h4>
                </div>
            `
        }),

        pdfWidgetsView: RivalIQ.apps.Dashboard.views.PdfWidgets,

        configurationModel: Configuration,

        loadConfiguration: function () {
            const me = this;

            return RivalIQ.data.reportConfigurations.fetch().then(function (configurations) {
                const configuration = configurations.get(me.getCurationId());
                return (!configuration ? null : new me.configurationModel(configuration.toJSON()));
            });
        }
    });
});
